import Web3 from 'web3'

import {
	coin
} from './abi.js'

// 获取web3实例
function getWeb3(callback){
	var web3 = window.web3;
	if (window.ethereum) {
		callback(new Web3(ethereum));
		return;
	}
	if (typeof web3 !== 'undefined') {
		callback(new Web3(web3.currentProvider));
		return;
	}
	callback(false)
}

async function linkWallet(callback){
    if (typeof window.ethereum !== 'undefined') {
        let addr = await ethereum.request({ method: 'eth_requestAccounts' });//授权连接钱包
        console.log('userAddress:',addr[0]);
		
		// 初始化web3
		getWeb3((web3js)=>{
			console.log(web3js);
			if(web3js == false){
				callback(false,-1,'')
				return;
			}
			window.web3js = web3js;
			
			// 初始化合约
			let c = coin;
			c.USDT.contract = new web3js.eth.Contract(coin.USDT.abi,coin.USDT.address);
			c.WEBC.contract = new web3js.eth.Contract(coin.WEBC.abi,coin.WEBC.address);
			// WEBC
			c.OIS.contract = new web3js.eth.Contract(coin.OIS.abi,coin.OIS.address);
		    c.USER.contract=new web3js.eth.Contract(coin.USER.abi,coin.USER.address);//自己合约
			// LDX
			c.LDX.contract=new web3js.eth.Contract(coin.LDX.abi,coin.LDX.address);//自己合约
			c.TBOIS.contract=new web3js.eth.Contract(coin.TBOIS.abi,coin.TBOIS.address);//自己合约
			// LP
			c.LPTH.contract=new web3js.eth.Contract(coin.LPTH.abi,coin.LPTH.address);//自己合约
			c.LDJS.contract=new web3js.eth.Contract(coin.LDJS.abi,coin.LDJS.address);//自己合约
			c.LDYBB.contract=new web3js.eth.Contract(coin.LDYBB.abi,coin.LDYBB.address);//自己合约
			c.LDSBL.contract=new web3js.eth.Contract(coin.LDSBL.abi,coin.LDSBL.address);//自己合约
			window.coins = c;
			
			// 监听切换网络ID，切换钱包
			ethereum.on("accountsChanged", function(accounts) {
				localStorage.removeItem("zxy_sign");
				localStorage.removeItem("addr");
				window.location.reload();
			});
			ethereum.on("chainChanged",()=>{
				localStorage.removeItem("zxy_sign");
				localStorage.removeItem("addr");
				window.location.reload();
			});
			let chainId = '-1'
			if(ethereum.networkVersion == 56 || ethereum.chainId == 56){
				chainId = 56;
			}
			
			callback(true,chainId,addr[0])
		})
    }else{
		callback(false,-1,'')
    }
}





export {
	linkWallet
}
